import { Component } from '@angular/core';

@Component({
	selector: 'cv-schema-render-room34-skeleton',
	templateUrl: './room-skeleton.component.html'
})
export class Room34SkeletonComponent {

}
